import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// One flat row for every AI admin surface. The persona prompts (field engineer, workflow
// creation) sit alongside Indexing and Testing rather than nested one level deeper, so there is
// a single place to look for "anything AI" instead of two tab bars stacked on each other.
//
// Tabs are NavLinks rather than local state so a tab is linkable and survives a reload — these
// are pages an admin shares with a colleague ("look at the indexing status"), not transient
// view toggles.
export default function AiTabs({ tabs, basePath }) {
  return (
    <ul className="nav nav-tabs" role="tablist">
      {tabs.map((tab) => (
        <li className="nav-item" role="presentation" key={tab.slug}>
          <NavLink
            to={`${basePath}/${tab.slug}`}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            role="tab"
          >
            {tab.icon && <i className={`bi ${tab.icon} me-1`} />}
            {tab.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
}

AiTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
  })).isRequired,
  basePath: PropTypes.string,
};

AiTabs.defaultProps = {
  basePath: '/admin/organization/ai',
};
